/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceTabletBolt = createReactComponent(
  "device-tablet-bolt",
  "IconDeviceTabletBolt",
  [
    [
      "path",
      {
        d: "M13.5 21h-7.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8",
        key: "svg-0"
      }
    ],
    ["path", { d: "M19 16l-2 3h4l-2 3", key: "svg-1" }],
    ["path", { d: "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", key: "svg-2" }]
  ]
);

export { IconDeviceTabletBolt as default };
//# sourceMappingURL=IconDeviceTabletBolt.js.map
